// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports -- Copilot immersive owns the remaining Content Preview Relay boundary.
import {CopilotRelayEnvironmentProvider} from '@github-ui/copilot-immersive-v1/components/CopilotRelayEnvironmentProvider'

export function TaskChatDataProvider({children}: {children: React.ReactNode}) {
  return <CopilotRelayEnvironmentProvider>{children}</CopilotRelayEnvironmentProvider>
}
